/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import { Flex, Option, Select } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormLabel } from 'src/components/Common/FormComponent';
import { Info } from 'src/components/Common/Info';
import { ApplyBoundEnum } from 'src/pages/Policy/utils/types';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

import { useApplyBoundStyle } from './style';
const allApplyBoundOptions = [
  {
    value: ApplyBoundEnum.incomming,
    label: 'policy.applyTo.scanningForIncomingMessage',
  },
  {
    value: ApplyBoundEnum.sentMessageOnly,
    label: 'policy.applyTo.scanningForSentMessageOnly',
  },
  {
    value: ApplyBoundEnum.all,
    label: 'policy.applyTo.scanningForAllMessage',
  },
];
const ApplyBound = React.memo(
  ({
    applyBoundValue,
    applyBoundKey,
    setApplyBound,
    options = [ApplyBoundEnum.incomming, ApplyBoundEnum.all],
    disabled = false,
  }: {
    applyBoundValue: ApplyBoundEnum;
    applyBoundKey: string;
    setApplyBound: (state: { [key: string]: ApplyBoundEnum }) => void;
    options?: ApplyBoundEnum[];
    disabled?: boolean;
  }) => {
    const { t } = useTranslation();
    // local state
    const { iconColor } = useApplyBoundStyle();
    const applyBoundTooltipMap = React.useMemo(() => {
      return {
        1: t('policy.tooltip.applyBound1'),
        2: t('policy.tooltip.applyBound2'),
        7: t('policy.tooltip.applyBound7'),
      };
    }, []);
    const applyBoundOptions = React.useMemo(() => {
      return allApplyBoundOptions.filter((item) =>
        options.includes(item.value)
      );
    }, [options]);
    useWhyDidYouUpdate('ApplyBound Base', {
      applyBoundValue,
      applyBoundKey,
      setApplyBound,
      options,
    });
    return (
      <Flex mt="16px" alignItems="flex-start">
        <FormLabel label={t('common.label.applyTo')} width="200px" />
        <Flex height="32px" alignItems="center" columnGap="2x">
          <Select
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              setApplyBound({ [applyBoundKey]: Number(e.target.value) });
            }}
            width="265px"
            value={applyBoundValue}
            disabled={disabled}
          >
            {applyBoundOptions.map((item) => (
              <Option key={item.value} value={item.value}>
                {t(item.label)}
              </Option>
            ))}
          </Select>
          <Info
            iconStyle={{ color: iconColor }}
            content={applyBoundTooltipMap[applyBoundValue]}
          />
        </Flex>
      </Flex>
    );
  }
);
export default React.memo(ApplyBound);
